/* eslint-disable jsx-a11y/label-has-for */
import React, { useCallback, useEffect, useState } from "react";
import { Button } from "react-blueprint-library";
import { useDispatch } from "react-redux";

import LostDataModal from "../../../../../../SharedComponents/LostDataModal";
import { logoutActions } from "../../../../../../../store/actions";

import "./CivJudCommentsForm.scss";
import NavigationButtons from "../../../../../../SharedComponents/NavigationButtons";

const CivJudCommentsForm = ({
  updateCCBForm,
  backFormId,
  nextFormId,
  getSubmitDataValues,
  data,
  groupKey,
  headerText,
}) => {
  const dispatch = useDispatch();
  const [showBackModal, setShowBackModal] = useState(false);
  const [comments, setComments] = useState(data || "");
  const [formHasChanged, setFormHasChanged] = useState(false);

  const onCommentsChangeHandler = ({ target: { value } }) => {
    setFormHasChanged(true);
    setComments(value);
  };

  const handleCloseBackModal = () => setShowBackModal(false);

  const isUpdates = formHasChanged;

  useEffect(() => {
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: true }));
  }, [isUpdates, dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);

    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  const handleShowBackModal = () => {
    if (formHasChanged) {
      setShowBackModal(true);
    } else {
      if (
        (data !== null && data && !Object.keys(data).length) ||
        data === null
      ) {
        getSubmitDataValues({ [groupKey]: null }, headerText);
      }
      updateCCBForm(backFormId);
    }
  };

  const handleBackClick = () => {
    if (!data) {
      getSubmitDataValues({ [groupKey]: null }, headerText);
    }
    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));
    updateCCBForm(backFormId);
    handleCloseBackModal();
  };

  const handleNext = useCallback(() => {
    getSubmitDataValues({ [`${groupKey}`]: comments }, headerText, true);

    dispatch(logoutActions.setShowLogoutModal({ showLogoutModal: false }));

    updateCCBForm(nextFormId);
  }, [
    updateCCBForm,
    nextFormId,
    getSubmitDataValues,
    comments,
    dispatch,
    groupKey,
    headerText,
  ]);

  return (
    <div className="civ-jud-comments-form-wrapper">
      <div className="civ-jud-comments-container">
        <label
          htmlFor="civJudCommentsId"
          id="civJudCommentsId"
          className="comments-label"
        >
          You may use this field to provide a brief summary of the circumstances
          leading to the action as well as the current status or final
          disposition. <span style={{ paddingLeft: "5px" }}>(Optional)</span>
        </label>
        <textarea
          id="civJudCommentsId"
          onChange={onCommentsChangeHandler}
          className="form-control"
          minLength={0}
          maxLength={500}
          rows="3"
          cols={500}
          value={comments}
        />
      </div>
      <NavigationButtons
        onBack={handleShowBackModal}
        onNext={handleNext}
        nxtbtnid={"civJudNext"}
        bckbtnid={"civJudBack"}
        nextBtnText={"Complete DRP"}
        isLoading={false}
        isDisabled={false}
      />
      <LostDataModal
        isOpen={showBackModal}
        handleClose={handleCloseBackModal}
        handleProceed={handleBackClick}
      />
    </div>
  );
};

export default CivJudCommentsForm;
